const fieldLabels = {
  first_name: 'First name',
  last_name: 'Last name',
  email: 'Email',
  phone: 'Phone',
  role: 'User type',
  commission: 'Commission',
  discount: 'Maximum discount',
  discount_type: 'Discount type',
  is_active: 'User status'
};
const genericMessage = 'Unable to save. Please try again.';

const collectMessages = (value) => {
  if (Array.isArray(value)) return value.flatMap(collectMessages);

  if (value && typeof value === 'object') {
    return Object.values(value).flatMap(collectMessages);
  }

  if (value === null || value === undefined || value === '') return [];
  return [String(value)];
};

const labelFor = (field) => {
  if (fieldLabels[field]) return fieldLabels[field];
  return field.replaceAll('_', ' ').replace(/^./, (letter) => letter.toUpperCase());
};

export const parseStaffApiError = (error) => {
  const status = error?.response?.status;
  const payload = error?.response?.data;

  if (!payload || (status && (status < 400 || status >= 500))) {
    return { fieldErrors: {}, message: genericMessage };
  }

  if (typeof payload === 'string' || Array.isArray(payload)) {
    const messages = collectMessages(payload);
    return {
      fieldErrors: {},
      message: messages.join('\n') || genericMessage
    };
  }

  if (typeof payload !== 'object') {
    return { fieldErrors: {}, message: genericMessage };
  }

  const fieldErrors = {};
  const summary = [];

  Object.entries(payload).forEach(([field, value]) => {
    const message = collectMessages(value).join(' ');
    if (!message) return;

    if (!['detail', 'non_field_errors'].includes(field)) {
      fieldErrors[field] = message;
      summary.push(`${labelFor(field)}: ${message}`);
      return;
    }

    summary.push(message);
  });

  return {
    fieldErrors,
    message: summary.join('\n') || genericMessage
  };
};

export const createStaffSubmissionError = (error) => {
  const parsed = parseStaffApiError(error);
  const submissionError = new Error(parsed.message);
  submissionError.userMessage = parsed.message;
  submissionError.fieldErrors = parsed.fieldErrors;
  return submissionError;
};
